import apiService from '../../services/apiService'

export default {
  getChannelByAccount: async function ({ commit }) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.get('channel_by_account', { business_id })
      if (response) {
        commit('SET_CHANNELTOKEN', response.data.data)
      }
      return response
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return error
    }
  },
  putCreateChannel: async function (
    store,
    { platform_channel_id, ...payload }
  ) {
    try {
      // console.log(commit);
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.put('update_channel', payload.data, {
        params: { platform_channel_id, business_id }
      })
      // console.log(response);
      return response
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return null
    }
  },
  postCreateChannel: async function (store, payload) {
    try {
      // console.log(commit);
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.post('create_channel', payload, {
        params: { business_id }
      })
      // console.log(response);
      return response
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return null
    }
  },
  deleteChannel: async function (store, { platform_channel_id }) {
    try {
      // console.log(commit);
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.delete('delete_channel', {
        platform_channel_id,
        business_id
      })
      return response
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return error
    }
  },
  selectChannel: async function ({ commit }, payload) {
    commit('SELECT_CHANNEL', payload)
  },

  checkManagePage: async function ({ commit }, payload) {
    commit('CHECK_MANAGE_PAGE', payload)
  }
}
